import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';import { AuthService } from 'epay-library';

@Component({
  selector: 'recurring-cc-add-cancel',
  templateUrl: './recurring-ccadd-cancel.component.html'
})
export class RecurringCCAddCancelComponent implements OnInit {


  pagetitle = 'Recurring Credit Card: Add Credit Card Cancel';

  confirmation = '';
  optOut = false;

  confirmationEmailAddress = '';

  sender = "Manage Credit Cards";

  constructor(    
    private route: ActivatedRoute,
    private router: Router,
    private authservice: AuthService,  ) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params: any) => {
      this.confirmation = params['confirmation'];
    });

    this.authservice.currentAccountEmail.subscribe(
      (email: string) => (this.confirmationEmailAddress = email)
    );

    if (this.router.url.includes('opt-out')) {
      this.optOut = true;
      this.pagetitle = 'Online Statements: Opt Out Successful'
    }
  }

  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(keyboardEvent: KeyboardEvent): void {

    // Swap default Print shortcut for print method
    switch (keyboardEvent.key) {
      case 'p': {
        if (keyboardEvent.ctrlKey) {
          keyboardEvent.preventDefault();
          //this.print();
          break;
        }
      }
    }
  }

  goToOptIn() {
    this.router.navigate(['/ncp/online-statements/settings']);
  }

  goToOptOut() {
    this.router.navigate(['/ncp/online-statements/settings']);
  }

  goHome() {
    this.router.navigate(['/home']);
  }

  goBack() {
    this.router.navigate(['/ncp/online-statements/settings']);
  }

}
